import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSandClock16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="hourglass">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 1H13V3.24477C13 4.94609 12.1349 6.53066 10.7038 7.45066L9.84926 8L10.7038 8.54934C12.1349 9.46934 13 11.0539 13 12.7552V15H3V12.7552C3 11.0539 3.8651 9.46934 5.29621 8.54934L6.15074 8L5.29621 7.45066C3.8651 6.53066 3 4.94608 3 3.24477V1ZM8 6.81119L9.62227 5.7683C10.4809 5.2163 11 4.26556 11 3.24477V3H5V3.24477C5 4.26556 5.51906 5.2163 6.37773 5.7683L8 6.81119ZM8 9.18881L6.37773 10.2317C5.51906 10.7837 5 11.7344 5 12.7552V13H11V12.7552C11 11.7344 10.4809 10.7837 9.62227 10.2317L8 9.18881Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
